module.exports = __webpack_public_path__ + "static/img/user-levels.5cdd680f.png";